import { render, staticRenderFns } from "./EditTableLanguageModel.vue?vue&type=template&id=6c8774dd&scoped=true&"
import script from "./EditTableLanguageModel.vue?vue&type=script&lang=js&"
export * from "./EditTableLanguageModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8774dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8774dd')) {
      api.createRecord('6c8774dd', component.options)
    } else {
      api.reload('6c8774dd', component.options)
    }
    module.hot.accept("./EditTableLanguageModel.vue?vue&type=template&id=6c8774dd&scoped=true&", function () {
      api.rerender('6c8774dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditTableLanguageModel.vue"
export default component.exports